import { Lens } from '@dhmk/zustand-lens';

import { UserSession } from '@/clients/portalAuth/types';

export type FlagType = Record<string, string | string[]> | undefined;

export type GlobalState = {
  featureFlags: FlagType | undefined;
  userSession: UserSession | undefined;
  hasHydrated: boolean;
};

export type GlobalActions = {
  setFeatureFlags: (flags: FlagType) => void;
  setUserSession: (userSession: UserSession) => void;
  setHasHydrated: (hasHydrated: boolean) => void;
};

export type GlobalSlice = GlobalState & { actions: GlobalActions };

const sliceName = 'global';
export const createGlobalSlice: Lens<GlobalSlice> = (set) => {
  return {
    featureFlags: undefined,
    userSession: undefined,
    hasHydrated: false,

    actions: {
      setFeatureFlags: (featureFlags) =>
        set({ featureFlags }, undefined, `${sliceName}/setFeatureFlags`),
      setUserSession: (userSession) =>
        set({ userSession }, undefined, `${sliceName}/setUserSession`),
      setHasHydrated: (hasHydrated: boolean) =>
        set({ hasHydrated }, undefined, `${sliceName}/hasHydrated`),
    },
  };
};
